export let childList = "child_list"
export let ChildInfo = "Child Info"
export let tp_info = "tp_info"
export let TP = "TP"
export let Customer_registration = "Customer Registration"
export let  Warranty_return = "Warranty Return"
export let  Warranty_return_update = "Warranty Return Update"

export let level1_info = 'level1_info'
export let level8_info = 'level8_info'
export let Level8_Details = "Level 8 Details"
export let Weight_Validation_Status = 'Weight Validation Status'
export let Pairing_Info = 'Pairing Information'
export let Level1_Details = "Level 1 Details"
export let trace_info = 'trace_info'
export let product_data = 'product_data'
export let ProductDetails = "Product Details"
export let functionalTestingHeader = "Functional Testing Parameters"
export let visualTestingHeader = "Visual Testing Parameters"
export let finalQcHeader = "Final QC Parameters"
export let Dispatch = "Dispatch"
export let tp_attributes = "TP Attributes"
export let transitInfo = "Transit Info"

//Custom Fields
export const validationRules = [
    {
        displayValue: "Please Select",
        value: ""
    },
    {
        displayValue: "Alpha,Numeric,Max 20 Chars",
        value: "alpha_num_space|max:20,string"
    },
    {
        displayValue: "Phone",
        value: "phone|numeric|min:0,num|size:10"
    },
    {
        displayValue: "Email",
        value: "email"
    },
    {
        displayValue: "Min 6 & Max 12 Chars",
        value: "min:6,string|max:12,string"
    },
    {
        displayValue: "Alpha Numeric",
        value: "alpha_num"
    },
    {
        displayValue: "Integer",
        value: "integer"
    },
    {
        displayValue: "Numeric",
        value: "numeric"
    },
    {
        displayValue: "Max",
        value: "max"
    },
    {
        displayValue: "Min",
        value: "min"
    },
    {
        displayValue: "Custom",
        value: "custom"
    }
]

export const customFieldTypes = [
    {
        displayValue: "Please Select",
        value: null
    },
    {
        displayValue: "Text",
        value: "text"
    },
    {
        displayValue: "Number",
        value: "number"
    },
    {
        displayValue: "Select",
        value: "select"
    },
    {
        displayValue: "Checkbox",
        value: "checkbox"
    },
    {
        displayValue: "Radio",
        value: "radio"
    },
]

export const customFields = {
    validationFieldRule: {
        elementType: "select",
        elementConfig: {
            placeholder: "Validation Rule",
            options: validationRules
        },
        id: "validationRule",
        value: null,
        label: "Validation Rule",
        validate: {
            required: true,
            rules: "required"
        },
        update: {
            required: false
        }
    },
    dependencyInputFieldRule: {
        elementType: "input",
        elementConfig: {
            type: "text",
            placeholder: "Endpoint"
        },
        id: "endpoint",
        value: null,
        label: "Endpoint",
        validate: {
            required: false,
            rules: "required"
        },
        update: {
            required: false
        }
    },
    fieldTypeFieldRule: {
        elementType: "input",
        elementConfig: {
            type: "text",
            placeholder: "Enter Option"
        },
        id: "fieldTypeFieldRule",
        value: null,
        label: "Enter Option",
        validate: {
            required: false,
        },
        update: {
            required: false
        }
    },
    fieldTypeFieldRuleButton: {
        elementType: "button",
        elementConfig: {
            type: "button",
            placeholder: "Enter Option",
            className: "button-disabled",
            disabled: true
        },
        id: "selectOptions",
        value: "Add Option",
        label: "Add Option",
        validate: {
            required: true,
            rules: "required"
        },
        update: {
            required: false
        }
    },
    customOptions: {
        elementType: "customOptions",
        elementConfig: {
            type: "customOptions",
            placeholder: ""
        },
        id: "customOptions",
        value: null,
        label: "Selected Options",
        validate: {
            required: false,
        },
        update: {
            required: false
        }
    },
    dummyInput: {
        elementType: "customOptions",
        elementConfig: {
            type: "customOptions",
            placeholder: "",
        },
        id: "dummyInput",
        value: null,
        label: "",
        validate: {
            required: false,
        },
        update: {
            required: false
        }
    },
}

export const customStep = {
    id: null,
    step: null,
    component: "step1",
    formValues: {},
    flag: false
}
    





